var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pageHeader"},[_c('div',{staticClass:"asidePart"},[(_vm.leftIcon)?_c('van-icon',{attrs:{"name":"arrow-left"},on:{"click":_vm.back}}):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"center van-hairline--top-bottom"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('div',{staticClass:"asidePart"})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-074fdd01","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/PageHeader.vue
// module id = null
// module chunks = 